import axios, { type AxiosInstance } from 'axios'
import { retrieveAuthToken } from './authUtils'

export const buildAxiosInstance = (): AxiosInstance => {
  const token = retrieveAuthToken()
  return axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
    headers: { Authorization: `Bearer ${token ?? ''}` },
    timeout: 30000
  })
}

export const DEFAULT_LIMIT = 10
export const SOURCE_NAME = 'PORTAL'
